module.exports = __webpack_public_path__ + "static/media/foco-sylvania.237d115e.png";